import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { first, map, switchMap, take } from 'rxjs/operators';

import { AuthService } from '@app/auth/auth.service';
import { UserService } from '@app/auth/user.service';

import { UserDataEnum } from './user.model';

@Injectable()
export class AuthGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly userService: UserService
  ) {}

  canActivate(): Observable<boolean> {
    const isProfileLoaded = Boolean(
      // TODO: replace for UserDataEnum.IsProfileLoaded when the app is updated
      this.userService.getUserData(UserDataEnum.Name)
    );

    return this.authService.isLoggedIn.pipe(
      take(1),
      switchMap((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          this.authService.logout();
        } else if (isLoggedIn && !isProfileLoaded) {
          return this.userService.getProfile().pipe(
            first(),
            map(() => true)
          );
        }

        return of(isLoggedIn);
      })
    );
  }
}
